import { WorkOrder } from '@xbcb/api-gateway-client';
import { CustomsBroker } from '@xbcb/party-schema';
import { isFbaScotForwarder } from '@xbcb/party-utils';
import { Tag } from '@xbcb/shared-types';
import { isEuCustomsEntry } from '@xbcb/work-order-utils/dist/isEuCustomsEntry';

export const isBrexitWorkOrder = (workOrder?: WorkOrder): boolean => {
  const isBrexitForwarder = workOrder?.group?.forwarders?.some((forwarder) =>
    isFbaScotForwarder(forwarder.forwarder),
  );
  return Boolean(isEuCustomsEntry(workOrder?.id) && isBrexitForwarder);
};

// TODO move tag key and value to @xbcb/shared-schema
// and change Program -> program and change Brexit -> BREXIT
export const doesBrokerHaveBrexitEnabled = (
  customsBroker?: CustomsBroker,
): boolean => {
  return (
    customsBroker?.tags?.some(
      (tag?: Tag) => tag?.key === 'Program' && tag?.value === 'Brexit',
    ) ?? false
  );
};
